import { PlusCircleIcon } from "@heroicons/react/24/outline";
import classNames from "classnames";
import React, { useState } from "react";
import { useDrop } from "react-dnd";
import { AdminManageGeneralChartState } from "../../hooks/use-admin-manage-general-chart";
import AdminManageGeneralChartRaceItem from "./admin-manage-general-chart-race-item";
import AdminManageGeneralChartNonPartisanRaceItem from "./admin-manage-general-chart-non-partisan-race-item";
import { checkRaceNames } from "../../../../../utils/checkNames";

const AdminGeneralChartRaces: React.FC<{
  state: AdminManageGeneralChartState;
  handleErrors: React.Dispatch<React.SetStateAction<{}>>;
  errors: any;
  candidatesNamesChecked: boolean;
}> = ({ state, handleErrors, errors, candidatesNamesChecked }) => {
  const {
    addNewRace,
    form: { formState },
    racesFieldArray: { fields: races },
  } = state;

  const [, drop] = useDrop(() => ({
    accept: "CHART-RACE",
    drop: () => ({}),
    collect: () => ({}),
  }));

  return (
    <>
      <div className="my-8 font-medium tracking-widest uppercase">
        Build Election Test Chart
      </div>
      <div ref={drop}>
        {races.map((field, index) => {
          return (
            <div key={`field-${field.id}`}>
              {(() => {
                if (field.raceType === 'Partisan') {
                  return (
                    <AdminManageGeneralChartRaceItem
                      index={index}
                      field={field}
                      checkNames={checkRaceNames}
                      errorsArr={errors}
                      handleErrors={handleErrors}
                      manageGeneralChartState={state}
                      candidatesNamesChecked={candidatesNamesChecked}
                    />
                  )
                } else {
                  return (
                    <AdminManageGeneralChartNonPartisanRaceItem
                      index={index}
                      field={field}
                      checkNames={checkRaceNames}
                      errorsArr={errors}
                      handleErrors={handleErrors}
                      manageGeneralChartState={state}
                      candidatesNamesChecked={candidatesNamesChecked}
                    />
                  )
                }
              })()
              }
            </div>
          )
        }
        )}
      </div>
      <button
        onClick={addNewRace}
        type="button"
        className={classNames(
          "border border-primary-blue border-opacity-50 bg-[#E6EBF5] w-full font-semibold py-12 flex justify-center items-center mb-8 text-primary-blue rounded-md",
          { "border-red-500 focus:outline-red-500": formState.errors.races }
        )}
      >
        <PlusCircleIcon className="w-6 mr-2" />
        Add Another Race
      </button>
    </>
  );
};

export default AdminGeneralChartRaces;
